<template>
  <div>
    <b-carousel id="carousel-1" class="carousel-center" :interval="0" controls indicators background="#ababab"
      img-width="1024" img-height="334" style="text-shadow: 1px 1px 2px #333;" v-if="isHomepage">
      <div>
        <b-carousel-slide :key="headerCarouselItem.id" v-for="headerCarouselItem in headerCarousel"
          :img-src="headerCarouselItem.imagePath"><!-- :caption="headerCarouselItem.headerTitle" -->
          <h1 id="slideTitleH1" class="mb-2">{{ headerCarouselItem.headerTitle }}</h1>
          <h4 class="mt-0 d-none d-sm-block">{{ headerCarouselItem.headerSubtitle }}</h4>
          <div class="d-none d-md-block homeButtonsContainer">
            <div class="home-buttons-holder text-center mt-4 d-none d-sm-block" v-if="isHomepage">
              <b-button v-if="!isAuthenticated" :to="{ name: 'Register', query: { redirect: $route.fullPath } }"
                class="btn-transparent mr-2 text-white" alt="Sign Up" title="Sign Up">Sign Up</b-button>
              <b-button href="/projects/create" class="btn-blue text-white"
                alt="Create Your Own New Citizen Science Project"
                title="Create Your Own New Citizen Science Project">Create a Project</b-button>
            </div>
            <div style="margin-top:40px; width:100%; height:70px;">
              <div style="height:50px; bottom:0px; background-color: rgba(0, 0, 0, 0.4);">
                <b-button id="valuePropLinkButton"
                  class="h-100 d-inline-block pt-1 font-weight-bold border-right border-white text-white w-25"
                  href="https://blog.citsci.org/2019/11/19/results-based-citizen-science/" target="NewWindow">
                  <span class="text-tertiary">transform your</span><br />
                  <span>Ideas to Impacts</span>
                </b-button>
                <b-button id="valuePropLinkButton"
                  class="h-100 d-inline-block font-weight-bold border-right border-white text-white w-25"
                  href="https://blog.citsci.org/2019/11/30/partner-with-us-to-write-successful-grants/"
                  target="NewWindow">
                  <span class="text-tertiary">partner with us to write</span><br />
                  <span>Successful Grants</span>
                </b-button>
                <b-button id="valuePropLinkButton"
                  class="h-100 d-inline-block font-weight-bold border-right border-white text-white w-25"
                  href="https://blog.citsci.org/2019/12/12/building-your-citizen-science-community/" target="NewWindow">
                  <span class="text-tertiary">understand your</span><br />
                  <span>Community Motivations</span>
                </b-button>
                <b-button id="valuePropLinkButton" class="h-100 d-inline-block font-weight-bold w-25 text-white"
                  href="https://blog.citsci.org/2019/12/09/protect-your-participant-privacy/" target="NewWindow">
                  <span class="text-tertiary">customize your</span><br />
                  <span>Privacy Options</span>
                </b-button>
              </div>
            </div>
          </div>
        </b-carousel-slide>
      </div>
    </b-carousel>

    <!--<b-carousel id="header-carousel"
              controls
              indicators
              background="#ababab"
              :interval="0"
              img-width="auto"
              img-height="450"
              v-if="isHomepage">

    <b-carousel-slide :key="headerCarouselItem.id" v-for="headerCarouselItem in headerCarousel" :img-src="headerCarouselItem.imagePath" >
      <b-row class="header-container">
        <b-col>
          <b-col class="header-holder text-center">
            <div class="header-text-holder">
              <h1 class="mb-1">{{headerCarouselItem.headerTitle}}</h1>
              <h4 class="mt-0 d-none d-sm-block">{{headerCarouselItem.headerSubtitle}}</h4>
            </div>
          </b-col>
          <b-row class="home-buttons-holder mt-4" v-if="isHomepage">
            <b-button v-if="!isAuthenticated" :to="{name: 'Register', query: { redirect: $route.fullPath }}" class="btn-transparent mr-2" style="color: #ffffff;" alt="Sign Up" title="Sign Up">Sign Up</b-button>
            <b-button href="/projects/create" class="btn-blue d-none d-sm-block" style="color: #ffffff;" alt="Create Your Own New Citizen Science Project" title="Create Your Own New Citizen Science Project">Create a Project</b-button>
          </b-row>
        </b-col>
      </b-row>
    </b-carousel-slide>
  </b-carousel>-->

    <b-container v-if="!isHomepage" fluid :style="{ 'background-image': 'url(' + headerData.backgroundPath + ')' }"
      class="HeaderContainer">

      <!-- Content here -->
      <div
        style="padding-left:15px; padding-right:15px; width: 1400px; height: 300px; border: solid 0px red; text-align: center; margin-right: auto; margin-left: auto;">

        <b-container v-if="isProjectProfile" class="ProjectProfileLogo HideResponsive"
          :style="{ 'background-image': 'url(' + headerData.picturePath + ')' }"></b-container>

        <b-container class="HeaderTitle">
          <h1 style="" class="text-break">{{ headerData.headerTitle }}</h1>
          <!--        <div class="btn-toolbar float-right" style="margin-top:-36px;">-->
          <!--          <div class="btn-group" style="margin-right: 0px;">-->
          <!--            <b-button pill variant="secondary" class="disabled mr-2" size="sm" title="Likes" alt="Likes">-->
          <!--              <i class="fa fa-heart"></i>-->
          <!--              <b-badge pill variant="dark">{{totalLikesForProject}}</b-badge>-->
          <!--            </b-button>-->
          <!--            <b-button pill variant="tertiary"-->
          <!--                      class="disabled mr-2"-->
          <!--                      size="sm"-->
          <!--                      title="Like this project"-->
          <!--                      alt="Like this project"-->
          <!--                      :disabled="isButtonClicked"-->
          <!--                      @click="onLikeButtonClick">-->
          <!--              <i class="fa fa-heart"></i>-->
          <!--              <span v-if="!isLiked" class="HideResponsive" disabled="isButtonClicked">Like</span>-->
          <!--              <span v-else class="HideResponsive" disabled="isButtonClicked" >Liked</span>-->
          <!--            </b-button>-->
          <!--            <b-button pill variant="tertiary" class="disabled" size="sm" title="Share this project" alt="Share this project">-->
          <!--              <i class="fa fa-share-alt"></i> <span class="HideResponsive">Share</span>-->
          <!--            </b-button>-->
          <!--          </div>-->
          <!--        </div>-->
        </b-container>

      </div>

    </b-container>

  </div>
</template>
<style lang="scss" scoped>
#slideTitleH1 {
    // Extra small devices (portrait phones, less than 576px)
    // No media query for `xs` since this is the default in Bootstrap
    font-size: 2rem;
    // Small devices (landscape phones, 576px and up)
    @media (min-width: 576px) { font-size: 2rem; }

    // Medium devices (tablets, 768px and up)
    @media (min-width: 768px) { font-size: 2.5rem; }

    // Large devices (desktops, 992px and up)
    @media (min-width: 992px) { font-size: 3rem; }

    // Extra large devices (large desktops, 1200px and up)
    @media (min-width: 1200px) { font-size: 3.5rem; }
}

.carousel-caption {
    padding-bottom: 0px !important;
}

.homeButtonsContainer {
    height:100px;
    // Small devices (landscape phones, 576px and up)
    @media (min-width: 576px) { height:100px; }

    // Medium devices (tablets, 768px and up)
    @media (min-width: 768px) { height:100px; }

    // Large devices (desktops, 992px and up)
    @media (min-width: 992px) { height:110px; }

    // Extra large devices (large desktops, 1200px and up)
    @media (min-width: 1200px) { height:150px; }
}

#valuePropLinkButton {
    float:left;
    margin:0;
    padding:0;
    background-color: rgba(0, 0, 0, 0.4);
    border:0;
}

#valuePropLinkButton:hover {
    background-color: rgba(0, 168, 217, 0.4);
}

.HeaderContainer {
    background-size: cover;
    background-position: center bottom;
    background-color: grey;
    height: 320px;
    overflow: hidden;
    text-align: right;
}

.ProjectProfileLogo {
    float: right;
    margin-top: 70px;
    margin-right: 0px;
    width: 160px;
    height: 96px;
    display: inline;
    background-size: auto 100%;
    background-position: center center;
}

.HeaderTitle {
    float: left;
    margin-top: 70px;
    width: 904px;
    min-height: 100px;
    height: fit-content; /* 100px */
    border: solid 0px white;
    display: inline;
    background: rgba(0, 0, 0, 0.5);

    @media screen and (max-width: 630px) {
        width: 480px;
    }

    & > h1 {
        font-size: 3.5rem; /* 3.5rem */
        color: #fff;
        text-align: left;
        margin-bottom: 0rem !important;
        word-break: break-all;

        /*@media screen and (max-width: 630px) {
            font-size: 2rem;
        }*/
    }
}

@media screen and (max-width: 1037px) {
    .HideResponsive {
        display: none;
    }
}

.header-image {
    height: 450px;
    width: 100%;
    background-position: center;
    text-align: center;
    background-size: cover;
    background-color: #00B0F0;
    margin-top:12px;
    margin-left: 0px !important;

    & > .header-container {
        margin: 56px auto;
        max-width: 1100px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        & .header-holder {
            padding-top: 56px;
            text-align: center;
            margin-left: auto;
            margin-right: auto;

            & > .header-text-holder {
                & > h1, h4 {
                    color: #fff;
                    display: flex;
                    width: fit-content;
                }
            }
        }
    }

    &.project-profile {
        height: 300px;
        display: flex;

        &.font-size-60 {
            h1 {
                font-size: 3.5rem;
            }
        }

        &.font-size-40 {
            h1 {
                font-size: 2.35rem;
            }

        }

        &.font-size-30 {
            h1 {
                font-size: 1.9rem;
            }

        }

        & > .header-container {
            & .header-holder {
                display: flex;
                margin: 0;
                justify-content: space-between;
                width: 100%;

                @media screen and (max-width: 1330px) {
                    margin-left: auto;
                    margin-right: auto;
                }

                @media screen and (max-width: 630px) {
                    margin-left: auto;
                    margin-right: auto;
                    padding-left:30px;
                    padding-right:30px;
                }

                & > .header-text-holder {
                    & > h1 {
                        text-align: center;
                        background: rgba(0, 0, 0, 0.5);
                        display: flex;
                        height: fit-content;
                        word-break: break-all;
                    }
                }

                & > .project-company-logo {
                    display: flex;
                    margin-right: 65px;

                    & > .project-profile-logo {
                        max-width: 130px;
                        max-height: 130px;
                        width:100%;
                        height: auto;
                    }
                }
            }
        }
    }

    &.homepage {
        & .header-container {
            justify-content: space-between;

            & .home-buttons-holder {
                margin: auto;
            }

            & .header-holder {
                max-width: 100%;

                & > .header-text-holder {
                    & h1, h4 {
                        max-width: 100%;
                        margin: auto;
                        color: #fff;
                        font-size: 60px;
                    }

                    & h4 {
                        font-size: 25px;
                    }
                }
            }
        }
    }
}

#header-carousel {
    max-height: 450px;
    width: auto;
    text-shadow: 1px 1px 2px #333;

    & .carousel-inner {
        max-height: 450px;
        width: auto;
    }

    & .carousel-item {
        max-height: 450px;

        &.active {
            display: flex;
            align-items: baseline;
            min-height: 240px;
        }
    }

    .home-buttons-holder {
        justify-content: center;

        @media screen and (max-width: 865px) {
            margin-top: 1rem !important;
        }
    }

    .header-container {
        text-align: center;

        .header-holder {
            & > .header-text-holder {
                h1, h4 {
                    color: #fff;
                }

                h1 {
                    font-size: 3.75rem;

                    @media screen and (max-width: 1030px) {
                        font-size: 3.125rem;
                    }

                    @media screen and (max-width: 865px) {
                        font-size: 3em;
                    }
                }

                h4 {
                    font-size: 1.5625rem;

                    @media screen and (max-width: 1030px) {
                        font-size: 1.25rem;
                    }

                    @media screen and (max-width: 865px) {
                        font-size: 0.9375rem;
                        margin-top: 1rem !important;
                    }
                }
            }
        }
    }
}
</style>
<script type="text/javascript">
import { mapGetters } from 'vuex'

export default {
  props: {
    headerData: {
      type: Object,
      default: () => ({
        backgroundPath: '/assets/images/header/default-project-header-banner.png',
        picturePath: '',
        headerTitle: 'CitSci 2.0',
        hasAccess: false,
        subHeaderTitle: '',
        showHomepageButtons: false
      })
    },
    isProjectProfile: {
      type: Boolean,
      default: true
    },
    isHomepage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      headerCarousel: [
        {
          id: 1,
          headerTitle: 'Helping you do great science',
          headerSubtitle: 'Create projects, build datasheets, collect data, and view results in real-time.',
          imagePath: '/assets/images/header/Home_Image_1.jpg'
        },
        {
          id: 2,
          headerTitle: 'Create your own projects',
          headerSubtitle: 'Make projects public, private, local, or global.',
          imagePath: '/assets/images/header/Home_Image_2.jpg'
        },
        {
          id: 3,
          headerTitle: 'Manage volunteers',
          headerSubtitle: 'Approve trained members, invite new members, email members, and create notifications.',
          imagePath: '/assets/images/header/Home_Image_3.jpg'
        },
        {
          id: 4,
          headerTitle: 'Build custom datasheets',
          headerSubtitle: 'Add species, picklists, site characteristics, locations, and more.',
          imagePath: '/assets/images/header/Home_Image_4.jpg'
        },
        {
          id: 5,
          headerTitle: 'Analyze your own data',
          headerSubtitle: 'Visualize trends. Make comparisons between locations. Assess relationships between variables.',
          imagePath: '/assets/images/header/Home_Image_5.jpg'
        },
        {
          id: 6,
          headerTitle: 'Get participant feedback',
          headerSubtitle: 'Create pre- and post-data collection surveys. Evaluate project effectiveness.',
          imagePath: '/assets/images/header/Home_Image_6.jpg'
        },
      ],
      fontSize: '60'
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'user/auth/isAuthenticated'
    }),

  },

  watch: {
    isHomepage(newIsHomepageValue) {
      this.isHomepage = newIsHomepageValue
    },
    headerData(newHeaderData) {
      if (newHeaderData.headerTitle.length <= 30) {
        this.fontSize = '60'
      } else if (newHeaderData.headerTitle.length > 30 && newHeaderData.headerTitle.length <= 60) {
        this.fontSize = '40'
      } else if (newHeaderData.headerTitle.length > 60 && newHeaderData.headerTitle.length <= 100) {
        this.fontSize = '30'
      }
    }
  }
}
</script>
